import React, { useState } from "react";
import "./Usdt.scss";
import ModalUSDT from "../ModalUsdt/ModalUsdt";
import { getFromlocalstorage } from "../../../../../component/MaHoaDuLieu/MaHoaDuLieu";
import Loading from "../../../../../component/Loading/Loading";
import Notify from "../../../../../component/Notify/Notify";

const DepositUSDT = () => {
  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const userData = JSON.parse(getFromlocalstorage("data_u"));

  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [depositData, setDepositData] = useState(null);

  // รายการจำนวนเงินที่แนะนำ
  const depositAmounts = [10, 50, 100, 500, 1000, 5000];

  const handleConfirm = async () => {
    const num = parseFloat(amount);

    if (isNaN(num)) {
      setError("กรุณากรอกจำนวนเงินที่ถูกต้อง");
      return;
    }

    if (num < 10) {
      setError("ยอดฝากขั้นต่ำคือ 10 USDT");
      return;
    }

    if (num > 50000) {
      setError("ยอดฝากสูงสุดคือ 50,000 USDT");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${apiUrl}/naptien/${userData._id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: num,
          type: "deposit-crypto",
        }),
      });

      const data = await res.json();

      if (res.ok) {
        setDepositData(data);
        setModalOpen(true);
      } else {
        setError(data.message || "ฝาก USDT ไม่สำเร็จ");
      }
    } catch (err) {
      setError("เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tab-content">
      <Loading isLoading={loading} />

      {/* รายการจำนวนเงินที่แนะนำ */}
      <div className="amount-list">
        {depositAmounts.map((val) => (
          <div
            key={val}
            className={`amount-item ${
              Number(amount) === val ? "selected" : ""
            }`}
            onClick={() => setAmount(val)}
          >
            {val} USDT
          </div>
        ))}
      </div>

      {/* ช่องกรอกจำนวนเงิน */}
      <div className="form-item required">
        <label className="form-label">
          จำนวนเงินฝาก (USDT):
        </label>

        <input
          type="number"
          className="input-inner"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="กรอกจำนวนเงิน"
        />
      </div>

      <div className="form-indent">
        <span>
          ยอดฝากขั้นต่ำ 10 USDT และสูงสุด 50,000 USDT
        </span>
      </div>

      {/* แสดงข้อความแจ้งเตือน */}
      {error && (
        <div className="form-indent error-msg red-font">
          {error}
        </div>
      )}

      {/* ปุ่มยืนยัน */}
      <div className="form-indent">
        <button
          type="button"
          className="btn-primary"
          onClick={handleConfirm}
        >
          ยืนยัน
        </button>
      </div>

      {/* Modal */}
      <ModalUSDT
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        amount={amount}
        depositData={depositData}
      />
    </div>
  );
};

export default DepositUSDT;